// extracted by mini-css-extract-plugin
module.exports = {"list":"BrandFilter-module--list--e829ac","label":"BrandFilter-module--label--260dba"};